"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const StyledLink = styled_components_1.default.a `
  display: inline-block;
  letter-spacing: 0;
  font-weight: 600;
  text-decoration: none;

  ${({ color }) => {
    if (color)
        return (0, styled_components_1.css) `
        color: ${color};
      `;
    return (0, styled_components_1.css) `
      color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
    `;
}}
`;
/**
 * Link component - Standard anchor <a> tag
 *
 * @param props.children Child components
 * @param props.href Sets href
 * @param props.newTab Open link in new tab
 * @param props.color Set css scolor or link
 * @param props.ReactComponent Set react component to use instead of <a>
 */
const Link = (props) => {
    const { children, href = "#", newTab = false, color = undefined, ReactComponent = undefined } = props, rest = __rest(props, ["children", "href", "newTab", "color", "ReactComponent"]);
    const targets = newTab
        ? {
            target: "_blank",
            rel: "noopenner noreferrer",
        }
        : undefined;
    const linkColor = color ? { color } : undefined;
    const linkHref = { href };
    if (typeof ReactComponent !== "undefined")
        return react_1.default.createElement(ReactComponent, Object.assign({}, props));
    return (react_1.default.createElement(StyledLink, Object.assign({}, linkHref, linkColor, targets, rest), children));
};
exports.default = Link;
//# sourceMappingURL=Link.js.map